import React, { useContext, useEffect, useState } from "react";
import { CBadge, CDropdown, CDropdownToggle } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { useHistory, useLocation } from "react-router-dom";
import Auth from "src/auth";
import { apiCallSPGet } from "src/_apiConfig/apiCall";
import MenuContext from "src/_components/ContextAPI";

const TheHeaderDropdownNotif = () => {
  const history = useHistory();
  const { authenticated } = Auth();
  const location = useLocation();
  //const [lastPath, setLastPath] = useState(location.pathname);

  const [itemsCount, setItemsCount] = useState(0);
  const [userData, setUserData] = useState([]);
  const [itemsLastCount, setLastItemsCount] = useState(itemsCount);
  const { cgmfRouteListData } = useContext(MenuContext);
  useEffect(() => {
    console.log("URL changed:", location.pathname);
    // Check if the current URL is different from the last URL
    //if (location.pathname !== lastPath || location.pathname === "/") {
    //console.log("URL changed:", location.pathname);
    // Update the lastPath to the current URL
    //setLastPath(location.pathname);
    getNotificationCount();
    // Perform your refresh logic here, for example, fetching new data
    //}

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, location]);
  //lastPath

  const onClickData = () => {
    //if (location.pathname !== lastPath) {
    getNotificationCount();
    //}
    history.push("/");
  };

  const data = [
    {
      header: userData?.hoBankGuaranteePayment,
      accesskey: "requestlist_bankguaranteelist",
    },
    {
      header: userData?.hoTransferLotApproval,
      accesskey: "requestlist_transfertoholotapprovals",
    },
    {
      header: userData?.hoIncomeTaxConcession,
      accesskey: "requestlist_incometaxconsessionrequest",
    },
    {
      header: userData?.hoPendingAgreementExtend,
      accesskey: "requestlist_PendingAgreementextendListHO",
    },
    {
      header: userData?.hoPendingUsersApproval,
      accesskey: "requestlist_pendingapprovals",
    },

    {
      header: userData?.hoLotLeftRequest,
      accesskey: "requestlist_lotleftrequestlistho",
    },
    {
      header: userData?.hoAdHocPaymentApprovalPending,
      accesskey: "lot_adhocpayment",
    },
    {
      header: userData?.hoAdHocPaymentClarificationMe,
      accesskey: "lot_adhocpayment",
    },
  ];
  const getNotificationCount = async () => {
    let url = "";
    if (authenticated && authenticated.role !== "Bidder") {
      if (authenticated.role === "CGMF") {
        url = `Notification/HO?userId=${authenticated.userId}`;
        await apiCallSPGet(url).then((res) => {
          if (res.success) {
            setUserData(res.data);
            setItemsCount(parseInt(res.totalRecord) || 0);
            setLastItemsCount(parseInt(res.totalRecord) || 0);
          }
        });
      } else if (authenticated.role === "CFO" || authenticated.role === "DFO") {
        if (authenticated.role === "CFO")
          url = `Notification/CCF/Count?userId=${authenticated.userId}`;
        else if (authenticated.role === "DFO")
          url = `Notification/DFO/Count?userId=${authenticated.userId}&districtId=${authenticated.district}`;

        await apiCallSPGet(url).then((res) => {
          if (res.success) {
            setItemsCount(parseInt(res.totalRecord) || 0);
            setLastItemsCount(parseInt(res.totalRecord) || 0);
          }
        });
      }
    }
  };

  const isAllow = (accesskey) => {
    return cgmfRouteListData?.some(
      (existingItem) => existingItem.accessKey === accesskey
    );
  };
  const getHoCount = () => {
    // Loop through each item in the data array
    let count = 0;

    // Use map to iterate through each item and update count conditionally
    data.forEach((item) => {
      if (isAllow(item.accesskey)) {
        count += item.header;
      }
    });

    // Return the final count value
    return count;
  };
  return (
    authenticated.role !== "Bidder" && (
      <CDropdown inNav className="c-header-nav-item mx-2">
        <CDropdownToggle
          className="c-header-nav-link"
          caret={false}
          onClick={onClickData}
        >
          <CIcon name="cil-bell" />
          <CBadge shape="pill" color="danger">
            {authenticated.role === "CFO" || authenticated.role === "DFO"
              ? itemsLastCount
              : getHoCount()}
          </CBadge>
        </CDropdownToggle>
      </CDropdown>
    )
  );
};

export default TheHeaderDropdownNotif;
